var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '{{amount}}€';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
let firstSwiperInstance = null;
let secondSwiperInstance = null;

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );
    this.input.addEventListener('input', this.enforceMax.bind(this));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  enforceMax() {
    const max = parseInt(this.input.max);
    const value = parseInt(this.input.value);
    const quantityWrapper = this.closest('.quick-add__wrapper');

    if (max && value > max) {
      if (quantityWrapper) {
        const text = this.dataset.noti || 'The maximum available quantity is';
        quantityWrapper.querySelector('.rocket__quantity-status-text').textContent = `${text} ${max}`;
      }
    } else {
      if (quantityWrapper) {
        quantityWrapper.querySelector('.rocket__quantity-status-text').textContent = '';
      }
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
    if (this.closest('.quick-add__wrapper')) {
      const listItem = document.querySelectorAll('.rocket-add__list-item');
      let total_price = 0;
      const multipleAdd = document.querySelector('.rocket-multiple-add');
      listItem.forEach((item) => {
        const price = parseInt(item.getAttribute('data-price'));
        const quantity = parseInt(item.querySelector('.quantity__input').value);
        total_price = total_price + quantity * price;
      });
      if (multipleAdd) multipleAdd.querySelector('.total-price span').innerHTML = Shopify.formatMoney(total_price);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );

    const headerCloseBtn = this.querySelector('.menu-drawer__header-close');
    if (headerCloseBtn) {
      headerCloseBtn.addEventListener('click', (event) => {
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      });
    }
    const drawerOverlay = this.querySelector('.header-drawer__overlay');
    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', (event) => {
        this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      });
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('menu-drawer-active');
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('menu-drawer-active');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    // if (this.classList.contains('media-modal')) {
    //   this.addEventListener('pointerup', (event) => {
    //     if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
    //   });
    // } else {
    //   this.addEventListener('click', (event) => {
    //     if (event.target === this) this.hide();
    //   });
    // }
    this.addEventListener('click', (event) => {
      if (event.target === this) this.hide();
    });
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    document.body.classList.add('modal-overflow-hidden');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    document.body.classList.remove('modal-overflow-hidden');
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const template = this.querySelector('template');
      if (!template) return;

      const content = document.createElement('div');

      Array.from(template.content.children).forEach((child) => {
        content.appendChild(child.cloneNode(true));
      });

      this.setAttribute('loaded', true);

      const deferredElements = content.querySelectorAll('video, model-viewer, iframe');
      deferredElements.forEach((deferredElement) => {
        this.appendChild(deferredElement);

        if (deferredElement.nodeName === 'IFRAME') {
          let src = deferredElement.getAttribute('src');
          if (src && !src.includes('mute=1')) {
            src += (src.includes('?') ? '&' : '?') + 'mute=1&enablejsapi=1';
            deferredElement.setAttribute('src', src);
          }

          deferredElement.addEventListener('click', function () {
            deferredElement.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
          });
        }

        if (focus && deferredElement.nodeName === 'VIDEO') {
          deferredElement.focus();
        }

        if (deferredElement.nodeName === 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          deferredElement.play();
        }
      });
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => {
      return element.clientWidth > 0;
    });
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages =
      this.slidesPerPage >= 1 ? this.sliderItemsToShow.length - this.slidesPerPage + 1 : this.sliderItemsToShow.length;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked &&
      this.desktopLayout.matches
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateStickyVariantSelects();
    this.updateVariantSku();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateColorName(this.currentVariant);
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    const metafieldInfo = document.querySelector('rocket-meta-fields-info');

    if (this.currentVariant && metafieldInfo) {
      metafieldInfo.dispatchEvent(
        new CustomEvent('variant-change', {
          detail: { variant: this.currentVariant },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  updateColorName(variant) {
    document.querySelectorAll('.js-selected-color').forEach((span) => {
      const index = parseInt(span.dataset.optionIndex, 10);

      if (variant.options[index]) {
        span.textContent = ' ' + variant.options[index];
      }
    });
    const availableProduct = document.querySelector('.js-variant-available');
    const unavailableProduct = document.querySelector('.js-variant-unavailable');

    // if (!availableProduct || !unavailableProduct) return;

    if (variant.available) {
      unavailableProduct.classList.add('hide');
      availableProduct.classList.remove('hide');
    } else {
      availableProduct.classList.add('hide');
      unavailableProduct.classList.remove('hide');
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true),
    );

    const rocketSliderPopup = document.querySelector(`#ProductModal-${this.dataset.section} rocket-slider-popup-media`);
    if (rocketSliderPopup && rocketSliderPopup.updateVariantMedia) {
      rocketSliderPopup.updateVariantMedia(this.currentVariant.featured_media.id);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateVariantSku() {
    if (!this.currentVariant) return;
    const sku = this.currentVariant.sku || '';
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      let skuInput = form.querySelector('.variant-sku-field');
      if (!skuInput) {
        skuInput = document.createElement('input');
        skuInput.type = 'hidden';
        skuInput.name = 'properties[_sku]';
        skuInput.className = 'variant-sku-field';
        form.appendChild(skuInput);
      }
      skuInput.value = sku;
    });
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const variantInfoSource = html.getElementById(
          `Variant-Info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
        );
        const variantInfoDestination = document.getElementById(`Variant-Info-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (variantInfoSource && variantInfoDestination) {
          variantInfoDestination.innerHTML = variantInfoSource.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut,
        );

        const stickyFormSource = html.querySelector(`.rocket-product-sticky-form .product-form__buttons`);
        const stickyFormDestination = document.querySelector(`.rocket-product-sticky-form .product-form__buttons`);
        const stickyIdSource = html.querySelector(`.rocket-product-sticky-form .product-variant-id`).value;
        const stickyIdDestination = document.querySelector(`.rocket-product-sticky-form .product-variant-id`);

        if (stickyFormSource && stickyFormDestination) {
          stickyFormDestination.innerHTML = stickyFormSource.innerHTML;
          if (stickyIdSource && stickyIdDestination) {
            stickyIdDestination.value = stickyIdSource;
          }
        }

        // Update sticky image when variant changes
        const stickyImgSource = html.querySelector(`.rocket-product-sticky-form .product-sticky-form__image-wrapper`);
        const stickyImgDestination = document.querySelector(
          `.rocket-product-sticky-form .product-sticky-form__image-wrapper`,
        );
        if (stickyImgSource && stickyImgDestination) {
          stickyImgDestination.innerHTML = stickyImgSource.innerHTML;
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateStickyVariantSelects() {
    const productStickyForm = document.querySelector('product-sticky-form');
    if (productStickyForm) {
      productStickyForm.syncWithMainSelector();
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let hasTriggered = false;

    const handleIntersection = (entries, observer) => {
      if (hasTriggered) return;
      if (entries && entries[0] && !entries[0].isIntersecting) return;
      hasTriggered = true;
      if (observer) observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('rocket-slider-complementary') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          const event = new CustomEvent('product-recommendations-loaded', {
            detail: {
              element: this,
            },
          });
          document.dispatchEvent(event);
        })
        .catch((e) => {
          console.error(e);
        });

      window.removeEventListener('click', triggerHandler, { once: true });
      window.removeEventListener('touchstart', triggerHandler, { once: true });
      window.removeEventListener('mousemove', triggerHandler, { once: true });
      window.removeEventListener('scroll', triggerHandler, { once: true });
    };

    const triggerHandler = () => {
      if (!hasTriggered) {
        handleIntersection();
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);

    window.addEventListener('click', triggerHandler, { once: true });
    window.addEventListener('touchstart', triggerHandler, { once: true });
    window.addEventListener('mousemove', triggerHandler, { once: true });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class RocketSeoDropdown extends HTMLElement {
  constructor() {
    super();
    this.accordionItems = this.querySelectorAll('.accordion-item');
    this.init();
  }

  init() {
    this.accordionItems.forEach((item) => {
      item.addEventListener('click', function () {
        this.classList.toggle('active');
        this?.querySelector('.accordion-item-body').classList.toggle('hidden');
      });
    });
  }
}

customElements.define('rocket-seo-dropdown', RocketSeoDropdown);

class RocketSliderProductsRelated extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.init();
  }

  init() {
    const elmSwiper = this.querySelector(`.swiper-related--${this.sectionId}`);
    if (elmSwiper) {
      firstSwiperInstance = new Swiper(elmSwiper, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
      });

      if (secondSwiperInstance) {
        firstSwiperInstance.controller.control = secondSwiperInstance;
        secondSwiperInstance.controller.control = firstSwiperInstance;
      }
    }
  }
}

customElements.define('rocket-slider-products-related', RocketSliderProductsRelated);

class RocketSliderProductsRelatedSecond extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.init();
  }

  init() {
    const elmSwiper = this.querySelector(`.swiper-related-second--${this.sectionId}`);
    if (elmSwiper) {
      secondSwiperInstance = new Swiper(elmSwiper, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: `.swiper-button-next--${this.sectionId}`,
          prevEl: `.swiper-button-prev--${this.sectionId}`,
        },
      });

      if (firstSwiperInstance) {
        firstSwiperInstance.controller.control = secondSwiperInstance;
        secondSwiperInstance.controller.control = firstSwiperInstance;
      }
    }
  }
}

customElements.define('rocket-slider-products-related-second', RocketSliderProductsRelatedSecond);

class RocketBrandsSwiper extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.initSwiper();
    this.handleHoverSection();
  }

  initSwiper() {
    const sliderIdentifier = this.sectionId;
    let config = {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 24,
      mousewheel: { forceToAxis: true },
      pagination: {
        el: `.swiper-pagination--${sliderIdentifier}`,
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: `.swiper-button-next--${sliderIdentifier}`,
        prevEl: `.swiper-button-prev--${sliderIdentifier}`,
      },
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 48,
        },
      },
    };

    if (this.dataset.desktopAutoScroll === 'true' && this.dataset.speed !== '0') {
      config.autoplay = {
        delay: this.dataset.speed,
        disableOnInteraction: false,
      };
    }

    if (this.querySelector(`.rocket-brands-swiper--${this.sectionId}`)) {
      this.swiper = new Swiper(`.rocket-brands-swiper--${this.sectionId}`, config);
    }
  }

  handleHoverSection() {
    // if user hovers on the section, stop autoplay and hover out, start autoplay again
    this.addEventListener('mouseleave', () => {
      if (this.dataset.desktopAutoScroll === 'true') {
        this.swiper.autoplay.start();
      }
    });

    this.addEventListener('mouseenter', () => {
      this.swiper.autoplay.stop();
    });
  }
}

customElements.define('rocket-brands-swiper', RocketBrandsSwiper);

class RocketCategoryList extends HTMLElement {
  constructor() {
    super();
    const heading = this.querySelector('.rocket-category-list__heading-mb');
    if (heading) {
      heading.addEventListener('click', (event) => {
        if (event.target.closest('.rocket-category-list__heading-mb') === heading) {
          const rocketContent = this.closest('.rocket-category-list__content');
          if (rocketContent) {
            rocketContent.classList.toggle('active');
          }
        }
      });
    }
  }
}

customElements.define('rocket-category-list', RocketCategoryList);

class RocketSliderProductsFeature extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.init();
  }

  init() {
    const elmSwiper = this.querySelector(`.swiper-feature--${this.sectionId}`);

    if (elmSwiper) {
      firstSwiperInstance = new Swiper(elmSwiper, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: `.swiper-button-next--${this.sectionId}`,
          prevEl: `.swiper-button-prev--${this.sectionId}`,
        },
      });
    }
  }
}

customElements.define('rocket-slider-products-feature', RocketSliderProductsFeature);

class RocketImageCarousel extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.imageUrls = [];
    this.currentIndex = 0;
    this.init();
  }

  init() {
    const elmSwiper = this.querySelector(`.swiper-carousel--${this.sectionId}`);

    if (elmSwiper) {
      this.swiperInstance = new Swiper(elmSwiper, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        breakpoints: {
          768: {
            spaceBetween: 8,
          },
        },
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: `.swiper-button-next--${this.sectionId}`,
          prevEl: `.swiper-button-prev--${this.sectionId}`,
        },
      });
    }

    this.initLightbox();
  }

  initLightbox() {
    const images = this.querySelectorAll('.carousel-image');

    this.imageUrls = Array.from(images).map((img) => img.getAttribute('src').split('?')[0]);
    this.totalImages = this.imageUrls.length;

    const lightboxHtml = `
      <div id="rocket-lightbox-modal" class="rocket-lightbox-modal">
        <div class="lightbox-inner">
          <span class="lightbox-close">
              <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none">
                <g clip-path="url(#clip0_5003_572432)">
                  <path d="M21.9688 0L1.96875 20M21.9688 20L1.96875 0" stroke="white"/>
                </g>
                <defs>
                  <clipPath id="clip0_5003_572432">
                    <rect width="22" height="22" fill="white" transform="translate(0.59375)"/>
                  </clipPath>
                </defs>
              </svg>
            </span>
          <img class="lightbox-content" />
          <div class="lightbox-control">
            <div class="lightbox-prev">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                  <path d="M3.59375 12C3.59375 11.8719 3.61075 11.7485 3.64476 11.63C3.67876 11.5106 3.74677 11.4052 3.84878 11.3137L9.48503 5.24706C9.62104 5.08235 9.79549 5 10.0084 5C10.2205 5 10.4031 5.08235 10.5562 5.24706C10.6922 5.41176 10.7602 5.60868 10.7602 5.8378C10.7602 6.0662 10.6922 6.26274 10.5562 6.42745L6.11858 11.1765L21.8286 11.1765C22.0497 11.1765 22.2326 11.2544 22.3775 11.4104C22.5217 11.5655 22.5937 11.7621 22.5937 12C22.5937 12.2379 22.5217 12.4348 22.3775 12.5907C22.2326 12.7459 22.0497 12.8235 21.8286 12.8235L6.11858 12.8235L10.5562 17.6C10.6922 17.7464 10.7646 17.9342 10.7735 18.1633C10.7816 18.3917 10.7092 18.5882 10.5562 18.7529C10.4031 18.9176 10.2205 19 10.0084 19C9.79548 19 9.62104 18.9176 9.48502 18.7529L3.84878 12.6863C3.74677 12.5948 3.67876 12.4897 3.64476 12.3711C3.61075 12.2518 3.59375 12.1281 3.59375 12Z" fill="white"/>
                </svg>
              </div>
            <div class="lightbox-number"></div>
            <div class="lightbox-next">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path d="M21.5937 12C21.5937 12.1281 21.5767 12.2515 21.5427 12.37C21.5087 12.4894 21.4407 12.5948 21.3387 12.6863L15.7025 18.7529C15.5665 18.9176 15.392 19 15.1791 19C14.967 19 14.7844 18.9176 14.6313 18.7529C14.4953 18.5882 14.4273 18.3913 14.4273 18.1622C14.4273 17.9338 14.4953 17.7373 14.6313 17.5725L19.0689 12.8235L3.35885 12.8235C3.13782 12.8235 2.95488 12.7456 2.81002 12.5896C2.66584 12.4345 2.59375 12.2379 2.59375 12C2.59375 11.7621 2.66584 11.5652 2.81002 11.4093C2.95488 11.2541 3.13782 11.1765 3.35885 11.1765L19.0689 11.1765L14.6313 6.4C14.4953 6.25359 14.4229 6.06583 14.414 5.8367C14.4059 5.60831 14.4783 5.41177 14.6313 5.24706C14.7844 5.08235 14.967 5 15.1791 5C15.392 5 15.5665 5.08235 15.7025 5.24706L21.3387 11.3137C21.4407 11.4052 21.5087 11.5103 21.5427 11.6289C21.5767 11.7482 21.5937 11.8719 21.5937 12Z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', lightboxHtml);

    this.lightboxModal = document.getElementById('rocket-lightbox-modal');
    this.lightboxContent = this.lightboxModal.querySelector('.lightbox-content');
    this.lightboxNumber = this.lightboxModal.querySelector('.lightbox-number');

    const closeBtn = this.lightboxModal.querySelector('.lightbox-close');
    const prevBtn = this.lightboxModal.querySelector('.lightbox-prev');
    const nextBtn = this.lightboxModal.querySelector('.lightbox-next');

    images.forEach((img, index) => {
      img.addEventListener('click', () => {
        this.currentIndex = index;
        this.openLightbox();
        document.body.classList.add('lightbox-open');
      });
    });

    prevBtn.addEventListener('click', () => {
      this.currentIndex = (this.currentIndex - 1 + this.totalImages) % this.totalImages;
      this.updateLightbox();
    });

    nextBtn.addEventListener('click', () => {
      this.currentIndex = (this.currentIndex + 1) % this.totalImages;
      this.updateLightbox();
    });

    closeBtn.addEventListener('click', () => {
      this.lightboxModal.style.display = 'none';
      document.body.classList.remove('lightbox-open');
    });

    this.lightboxModal.addEventListener('click', (e) => {
      if (e.target === this.lightboxModal) {
        this.lightboxModal.style.display = 'none';
        document.body.classList.remove('lightbox-open');
      }
    });
  }

  openLightbox() {
    this.updateLightbox();
    this.lightboxModal.style.display = 'flex';
  }

  updateLightbox() {
    this.lightboxContent.src = this.imageUrls[this.currentIndex];
    this.lightboxNumber.textContent = `${this.currentIndex + 1} / ${this.totalImages}`;
  }
}

customElements.define('rocket-image-carousel', RocketImageCarousel);

class RocketSliderProductsComplementary extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.init();
  }

  init() {
    const elmSwiper = this.querySelector(`.swiper-complementary--${this.sectionId}`);
    if (elmSwiper) {
      firstSwiperInstance = new Swiper(elmSwiper, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: `.swiper-button-next--${this.sectionId}`,
          prevEl: `.swiper-button-prev--${this.sectionId}`,
        },
      });
    }
  }
}

customElements.define('rocket-slider-complementary', RocketSliderProductsComplementary);

class RocketDownload extends HTMLElement {
  constructor() {
    super();
    this.option = this;
    this.option.addEventListener('click', (event) => {
      event.preventDefault();
      const document_name = event.currentTarget.getAttribute('data-name');
      const document_url = event.currentTarget.getAttribute('data-path');
      fetch(document_url)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = document_name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
          setTimeout(() => {
            this.container.classList.remove('active');
          }, 300);
        })
        .catch(console.error);
    });
  }
}

customElements.define('link-download', RocketDownload);

function handleResponsiveFilterMove() {
  const windowWidth = window.innerWidth;
  const facetsVerticalForm = document.querySelector('.facets-vertical-sort');
  const mobileContainer = document.getElementById('rocket-sorting__mb');
  const desktopContainer = document.getElementById('rocket-sorting__desktop');

  if (!facetsVerticalForm || !mobileContainer || !desktopContainer) return;

  if (windowWidth <= 749) {
    if (!mobileContainer.contains(facetsVerticalForm)) {
      mobileContainer.appendChild(facetsVerticalForm);
    }
  } else {
    if (!desktopContainer.contains(facetsVerticalForm)) {
      desktopContainer.appendChild(facetsVerticalForm);
    }
  }
}

handleResponsiveFilterMove();

window.addEventListener('resize', handleResponsiveFilterMove);

window.addEventListener('load', () => {
  const menuFooters = document.querySelectorAll('.footer-block--menu');
  menuFooters.forEach((menu) => {
    menu.querySelector('.footer-block__heading').addEventListener('click', (e) => {
      const dropdownActive = document.querySelector('.footer-block--menu.active');
      if (dropdownActive && dropdownActive !== menu) {
        dropdownActive.classList.remove('active');
      }
      menu.classList.toggle('active');
    });
  });
});

class AnnouncementClose extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('.announcement-bar__close');
    const target = this.closest('.rocket-announcement-bar');

    if (localStorage.getItem('announcementClosed') === 'true' && target) {
      target.style.display = 'none';
      return;
    }

    if (btn) {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (target) {
          target.style.display = 'none';
          localStorage.setItem('announcementClosed', 'true');
        }
      });
    }
  }
}

customElements.define('announcement-close', AnnouncementClose);

class ProductDescriptionToggle extends HTMLElement {
  constructor() {
    super();
    this.text = null;
    this.button = null;
    this.collapsedClass = 'has__line-clamp';
  }

  connectedCallback() {
    this.text = this.querySelector('.text');
    this.button = this.querySelector('#showMoreBtn');

    if (!this.text || !this.button) return;

    const isOverflowing = this.text.scrollHeight > this.text.clientHeight;

    if (isOverflowing) {
      this.button.style.display = 'inline-block';
    }

    // Gán nhãn ban đầu
    this.button.textContent = this.button.dataset.viewmore;

    this.button.addEventListener('click', () => this.toggleText());
  }

  toggleText() {
    const isCollapsed = this.text.classList.contains(this.collapsedClass);

    this.text.classList.toggle(this.collapsedClass);
    this.button.textContent = isCollapsed ? this.button.dataset.viewless : this.button.dataset.viewmore;
  }
}

customElements.define('product-description-toggle', ProductDescriptionToggle);

class HoverMenu extends HTMLElement {
  connectedCallback() {
    const listItems = this.querySelectorAll('.mega-menu__list__item');

    listItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        listItems.forEach((i) => i.classList.remove('menu_active'));
        item.classList.add('menu_active');
      });
    });
  }
}

customElements.define('hover-menu', HoverMenu);

document.addEventListener('DOMContentLoaded', () => {
  const hoverMenuItems = document.querySelectorAll('.mega-menu__item, .dropdown-menu__item');
  hoverMenuItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      document.body.classList.add('menu-drawer-active');
    });
    item.addEventListener('mouseleave', () => {
      document.body.classList.remove('menu-drawer-active');
    });
  });
});
